(function() {
    var inner = document.getElementById('hgCarouselInner');
    if (!inner) return;
    var indicators = document.querySelectorAll('.hg-indicator');
    var total = 3;
    var current = 0;
    var timer;

    function goTo(index) {
        current = index;
        inner.style.transform = 'translateX(-' + (100 / total * index) + '%)';
        indicators.forEach(function(dot, i) {
            dot.classList.toggle('active', i === index);
        });
    }

    function next() {
        goTo((current + 1) % total);
    }

    indicators.forEach(function(dot, i) {
        dot.addEventListener('click', function() {
            clearInterval(timer);
            goTo(i);
            timer = setInterval(next, 4000);
        });
    });

    timer = setInterval(next, 4000);
})();